import Transition, { type TransitionProps } from './transition';

export type SlideDirection = 'up' | 'down' | 'left' | 'right';

export interface SlideProps extends Omit<TransitionProps, 'transitionClasses'> {
  /**
   * Direction the child node will enter from.
   * @default 'down'
   */
  direction?: SlideDirection;
}

function Slide({ direction = 'down', timeout, ...props }: SlideProps) {
  return (
    <Transition
      {...props}
      timeout={timeout ?? 600}
      transitionClasses={{
        base: 'transform transition-transform ease-in-out',
        exit: directionMap[direction],
      }}
    />
  );
}

Slide.displayName = 'GooeySlide';

export default Slide;

/*
|------------------
| Internal
|------------------
*/

const directionMap: Record<SlideDirection, string> = {
  up: 'translate-y-full',
  down: '-translate-y-full',
  left: 'translate-x-full',
  right: '-translate-x-full',
};
